<p-card styleClass="flex w-full h-full p-4">
    <ng-template pTemplate="header">
        <div class="flex justify-between items-center">
            <h2>Pulse</h2>
            <app-icon-button 
                *ngIf="canAddAlert()"
                [icon]="icons.solid.faCirclePlus" 
                textSize="text-lg" 
                [pTooltip]="'Create an Alert'" 
                [showDelay]="500"
                (click)="addAlert()">
            </app-icon-button>
        </div>
    </ng-template>
    <div class="flex flex-col gap-2 w-full h-full mini-scrollbar overflow-y-auto" style="max-height: 780px;">
        <!-- Loading Spinner with improved UX -->
        <div *ngIf="isLoading()" class="flex justify-center items-center h-64">
            <div class="flex flex-col items-center gap-3">
                <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                <p class="text-gray-500 text-sm">Loading the pulse...</p>
                <div class="text-xs text-gray-400">This will load first for optimal performance</div>
            </div>
        </div>
        
        <!-- Content when loaded -->
        <div *ngIf="!isLoading() && hasAttemptedLoad()" class="animate-fade-in">
            <div *ngFor="let bulletin of bulletins()!; trackBy: trackByBulletin" class="bulletin-item w-full mb-3">
                <p-card styleClass="p-card-shadow-2 w-full bulletin-card">
                    <div class="flex flex-col w-full">
                        <div class="flex flex-col gap-2 w-full">
                            <div class="text-sm text-gray-500">
                                {{bulletin.staffName}} - {{bulletin.timestamp | date:'M/d/yy h:mm a'}}
                            </div>
                            <div class="bulletin-content w-full" 
                                 #contentContainer>
                            </div>
                            
                            <!-- Read Confirmation - Only show for most recent bulletin -->
                            <div *ngIf="isMostRecentBulletin(bulletin)" class="mt-4 pt-4 border-t border-gray-200">
                                <!-- Show message if already read -->
                                <div *ngIf="hasReadPulse()" class="flex items-center gap-2 text-green-600 text-sm">
                                    <i class="fas fa-check-circle"></i>
                                    <span>You have acknowledged that this Pulse has been read</span>
                                    <span *ngIf="readTimestamp()" class="text-gray-500 text-xs">
                                        ({{readTimestamp() | date:'M/d/yy h:mm a'}})
                                    </span>
                                </div>
                                
                                <!-- Show checkbox and button if not read yet -->
                                <div *ngIf="!hasReadPulse()" class="flex flex-col gap-3">
                                    <div class="flex items-center gap-2">
                                        <input 
                                            type="checkbox" 
                                            [id]="'pulse-read-checkbox-' + bulletin.id"
                                            [checked]="hasReadCheckbox()"
                                            [disabled]="isSubmitting()"
                                            (change)="hasReadCheckbox.set($any($event.target).checked)"
                                            class="w-4 h-4 text-primary-600 bg-gray-100 border-gray-300 rounded focus:ring-primary-500 focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                        />
                                        <label 
                                            [for]="'pulse-read-checkbox-' + bulletin.id" 
                                            class="cursor-pointer text-gray-700 text-sm">
                                            I acknowledge that I have read this Pelican Pulse
                                        </label>
                                    </div>
                                    
                                    <button 
                                        pButton 
                                        type="button"
                                        class="p-button-primary w-full sm:w-auto"
                                        [disabled]="!hasReadCheckbox() || isSubmitting()"
                                        (click)="confirmRead()">
                                        <span *ngIf="isSubmitting()">Submitting...</span>
                                        <span *ngIf="!isSubmitting()">Confirm</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-card>
            </div>
            <!-- Only show "no content" message when not loading AND we've attempted to load AND bulletins is empty array -->
            <div *ngIf="!isLoading() && hasAttemptedLoad() && bulletins() !== null && bulletins()!.length === 0" class="text-center p-3 text-gray-500">
                <div class="flex flex-col items-center gap-2">
                    <i class="fas fa-info-circle text-gray-400 text-lg"></i>
                    <p>No pulse to display</p>
                    <p class="text-xs text-gray-400">All clear! No active alerts at this time.</p>
                </div>
            </div>
        </div>
    </div>
</p-card>
